<template>
<section class="">
	
	<div class="d-flex justify-content-end nav-icon link-icon-mobile">
		<a class="nav-link icon-position" v-b-modal.ModalMap centered ><span class="material-icons bleu-vignon">place</span></a>
		<a class="nav-link" href="mailto:emmanuellevignon@gmail.com?subject=Demande de rensignements" ><span class="material-icons bleu-vignon">mail_outline</span></a>
		<a class="nav-link icon-position" v-b-modal.ModalTarifs centered><span class="material-icons bleu-vignon">euro</span></a>
	</div>
	<nav class="navbar navbar-expand-lg navbar-light fixed-top" :class="{ 'top-nav-collapse': $route.path != '/' }" role="navigation">
		<div class="container">
			<div class="navbar-header page-scroll" >
			<button :class="{collapsed: !menuClose}" @click="menuClose=!menuClose" class="navbar-toggler navbar-toggler-right" type="button">
			<span class="icon-bar top-bar"></span>
			<span class="icon-bar middle-bar"></span>
			<span class="icon-bar bottom-bar"></span>               
			</button>
			</div>
		
			<transition name="fade">
			<div class="overlay" :class="{OverlayVisible: menuClose}" v-if="menuClose"></div>
			</transition>
		
			<div class="collapse navbar-collapse navbar-ex1-collapse" :class="{show: menuClose}">
		
			<ul :class="{navbarNav: !menuClose, navburger: menuClose}">
			<li class="nav-item">
			<router-link class="" :to="{name: 'Particuliers'}">Particuliers</router-link>
			</li>
			<li class="nav-item">
			<router-link class="" :to="{name: 'Entreprises'}">Entreprises</router-link>
			</li>
			<li class="nav-item">
			<router-link class="" :to="{name: 'Relax'}">Sophro-Relax</router-link>
			</li>
			<li class="nav-item">
			<router-link class="" :to="{name: 'Accompagnements'}">Mes Accompagnements</router-link>
			</li>
			<li class="nav-item">
			<a class="" v-b-modal.ModalContact centered data-bs-toggle="modal" data-bs-target="#ModalContact" >Qui Suis-je ?</a>
			</li>
			</ul>
			
			<ul class="navbar-nav ms-auto mb-2 mb-lg-0 justify-content-end link-icon link-icon-desktop">
			<li class="nav-item">
			<a class="nav-link" v-b-modal.ModalMap centered data-bs-toggle="modal" data-bs-target="#ModalMap"><span class="material-icons bleu-vignon">place</span></a>
			</li>
			<li class="nav-item">
			<a class="nav-link" href="mailto:emmanuellevignon@gmail.com?subject=Demande de renseignements" ><span class="material-icons bleu-vignon">mail_outline</span></a>
			</li>
			<li class="nav-item">
			<a class="nav-link" v-b-modal.ModalTarifs centered data-bs-toggle="modal" data-bs-target="#ModalTarifs" ><span class="material-icons bleu-vignon">euro</span></a>
			</li>
			</ul>
		
			</div>
		<!-- /.navbar-collapse -->
		</div>
	<!-- /.container -->
	</nav>
	<!-- ------------------------------- Modal Tarifs ------------------------------------------------- -->         
        <ModalTarifs></ModalTarifs>
<!-- ------------------------------- Modal Map ------------------------------------------------- -->         
        <ModalMap></ModalMap>
<!-- ------------------------------- Modal Contact ------------------------------------------------- -->         
        <ModalContact></ModalContact>
</section>	
</template>

<script>
import ModalTarifs from './ModalTarifs.vue'
import ModalMap from './ModalMap.vue'
import ModalContact from './ModalContact.vue'
export default {
	name: 'navbar',
    components: {
    ModalTarifs,
    ModalMap,
    ModalContact
    },
    data: function(){
        return{
            menuClose: false
        }   
    },
    watch: {
    '$route' () {
      this.menuClose = false
    }
  }
}
</script>


<style scoped>
@media (min-width: 991px) {
.nav-icon{
	display: none!important;
}
.navbar-collapse{
	font-size: 1rem;
}
.page-scroll{
	display: none;
}
.navbarNav{
	width: 80%;
	padding-left:0;
}
.link-icon-desktop{
	width: 20%;
}
.link-icon-mobile{
	display: none;
}
}
@media (max-width: 990px) {
.navbar-collapse{
	font-size: 1rem;
}
.navbar-brand{
	display: none;
}
.link-icon-desktop{
	display: none;
}
.link-icon-mobile{
	position: fixed;
	z-index: 1040;
	right: 0;
}
.nav-link{
	padding: 1.25rem 0.5rem!important;
}
}
.nav-link, .material-icons.bleu-vignon {
	color: rgb(29,41,164)!important;
}
	
.navbar-toggler{
    position: absolute;
    left: 0;
    z-index: 1500;
}
.navbarNav li{
    margin-right: 40px;
    text-align: center;
}
.navbarNav{
	display: flex;
	flex-direction: row;
	list-style: none;
}
.navbarNav li a{
    color: rgb(29,41,164);
}
.navbarNav .router-link-active{
    border-bottom: solid 2px rgb(29,41,164);
}
.icon-bar {
	width: 22px; 
	height: 2px;
	background-color: white;
	display: block;
	transition: all 0.2s;
	margin-top: 4px
}
/****************** Hamburger menu Navigation **********************************/	  

.navbar-header {
    position: relative;
    width: 100%;
    height: 40px;
}
.navbar-left,
.navbar-right {
    float: none !important;
}
.navbar-toggle {
    display: block;
}
.navbar-fixed-top {
    top: 0;
}
.navbarNav {
    float: none!important;
    margin-bottom: 0!important;
}
.navbarNav>li {
    float: none;
}
.navbarNav>li>a {
    padding-top: 10px;
    padding-bottom: 10px;
}


/******************** Hamburger Menu pleine page *********************/

.navbar-toggler {
  border: none;
  background: transparent !important;
  margin-top: 0.75rem;
}
.navbar-toggler .top-bar {
  transform: translate(3px);
  transform: rotate(45deg);
  transform-origin: 10% 10%;
  background-color: rgb(29,41,164);
}
.navbar-toggler .middle-bar {
  opacity: 0;
}
.navbar-toggler .bottom-bar {
  transform: rotate(-45deg);
  transform-origin: 10% 90%;
  background-color: rgb(29,41,164);
}
.navbar-toggler.collapsed .top-bar {
  transform: rotate(0);
  background-color: rgb(29,41,164);
}
.navbar-toggler.collapsed .middle-bar {
  opacity: 1;
  background-color: rgb(29,41,164);
}
.navbar-toggler.collapsed .bottom-bar {
  transform: rotate(0);
  background-color:rgb(29,41,164);
}
/******************** Overlay *********************/
.overlay {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url(../assets/img/aquarelle.jpg);
    left: 0;
    display: none;
}
.OverlayVisible{
	display: block;
}
nav .show{
    position: fixed;
    top: 0;
    left: 0;
    text-align: center;
    transition: 0.5s;
    width: 100%;
    height: 100%;
}
nav .show ul.navburger{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    padding-left: 0;
}
nav .show ul li{
	list-style: none;
}
nav .show ul li a{
	color: rgb(29,41,164);
}

</style>
